/**
 * Custom JavaScript for PDQ Tracking Page
 * This script runs on https://fohertybrand.shop/pages/pdq-tracking-page
 */

(function() {
  'use strict';

  // Function to move pdqtrackingpage element into first column
  function movePdqTrackingPage() {
    const pdqElement = document.querySelector('pdqtrackingpage');
    const firstColumn = document.querySelector('.tracking-page__column');

    if (pdqElement && firstColumn) {
      // Check if already wrapped and moved to avoid duplicate moves
      const existingWrapper = pdqElement.closest('.pdq-tracking-wrapper');
      if (existingWrapper && existingWrapper.parentElement === firstColumn) {
        console.log('PDQ tracking page already in first column');
        return true;
      }

      // Create wrapper div if it doesn't exist
      let wrapper = existingWrapper;
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'pdq-tracking-wrapper';
      }

      // If element is not already in the wrapper, move it
      if (pdqElement.parentElement !== wrapper) {
        wrapper.appendChild(pdqElement);
      }

      // Move the wrapper into the first column
      firstColumn.appendChild(wrapper);
      console.log('PDQ tracking page moved to first column with wrapper');
      return true;
    }

    return false;
  }

  // Use MutationObserver to watch for pdqtrackingpage element
  function setupMutationObserver() {
    const observer = new MutationObserver(function(mutations) {
      const pdqElement = document.querySelector('pdqtrackingpage');
      if (pdqElement) {
        movePdqTrackingPage();
        // Stop observing once we've moved it
        observer.disconnect();
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return observer;
  }

  // Wait for pdqtrackingpage element to load (with timeout as fallback)
  function waitForPdqElement(maxAttempts = 50, interval = 200) {
    let attempts = 0;

    // Try immediately first
    if (movePdqTrackingPage()) {
      return;
    }

    // Set up MutationObserver for efficient detection
    const observer = setupMutationObserver();

    // Fallback polling (in case MutationObserver doesn't catch it)
    const checkInterval = setInterval(function() {
      attempts++;

      if (movePdqTrackingPage()) {
        clearInterval(checkInterval);
        observer.disconnect();
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        observer.disconnect();
        console.warn('PDQ tracking page element not found after', maxAttempts * interval / 1000, 'seconds');
      }
    }, interval);
  }

  // Wait for DOM to be ready
  function init() {
    console.log('PDQ Tracking Page script loaded');

    // Start waiting for the pdqtrackingpage element
    waitForPdqElement();

    // Also listen for PDQ widget events (if applicable)
    document.addEventListener('pdq:tracking:loaded', function(event) {
      console.log('PDQ tracking widget loaded', event);
      // Try to move it when the event fires
      setTimeout(movePdqTrackingPage, 100);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on section loads (for Shopify theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && event.detail.sectionId.includes('tracking-page')) {
      init();
    }
  });
})();

